module.exports = __webpack_public_path__ + "static/PA-f7acc4b69695fa0f5656afd549af2414.svg";